































import CoButton from '../../Atoms/co-button/CoButton.vue';
import CoModal from '../../Organisms/co-modal/CoModal.vue';

export default {
    components: { CoModal, CoButton },
    name: 'CoConfirmation',
    props: {
        message: {
            type: String,
        },
        confirmVariant: {
            type: String,
            default: 'default',
        },
        confirmLabel: {
            type: String,
            default: null,
        },
        cancelLabel: {
            type: String,
            default: null,
        },
        cancelVariant: {
            type: String,
            default: null,
        },
        modalSize: {
            type: String,
            default: 'sm',
        },
        disableConfirm: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            confirmed: false, // to track confirmation state
        };
    },
    mounted() {
        // If the default slot is used, add a click event listener to the first element
        this.$slots.default?.forEach((slot) => {
            slot.elm?.addEventListener('click', this.show);
        });
    },
    methods: {
        show() {
            this.$emit('launch');
            this.$refs.confirmationModal.show();
        },
        confirm() {
            this.confirmed = true;
            this.$emit('confirm');
            this.$refs.confirmationModal.hide();
        },
        cancel() {
            this.$emit('cancel');
            this.$refs.confirmationModal.hide();
        },
        discarded() {
            // by clicking outside the modal
            // if confirmed is true, it means the user clicked confirm button first
            // if so, we reset confirmed and do not emit discarded event
            // if confirmed is false, emit discarded event as usual its either cancel button or click away
            if (this.confirmed) {
                this.confirmed = false;
                return;
            }
            this.$emit('discarded');
        },
    },
};
